import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';

/**
 * Footer — editorial hairline footer.
 * brand + tagline (left) · meta links (right) · year + locale shorthand bottom-right.
 * Single hairline border-top. Mono small uppercase meta. No heavy treatment.
 */
export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bq-footer" role="contentinfo">
      <div className="bq-footer__inner">
        <div className="bq-footer__brand">
          <span className="bq-footer__mark">BookQuest</span>
          <span className="bq-footer__sub">{t('footer.tagline')}</span>
        </div>

        <nav className="bq-footer__nav" aria-label={t('footer.navLabel')}>
          <Link to="/larc" className="bq-footer__link">{t('footer.larc')}</Link>
          <a href="#about" className="bq-footer__link">{t('footer.about')}</a>
          <a href="#privacy" className="bq-footer__link">{t('footer.privacy')}</a>
          <a href="#terms" className="bq-footer__link">{t('footer.terms')}</a>
          <a href="#contact" className="bq-footer__link">{t('footer.contact')}</a>
        </nav>

        <div className="bq-footer__meta">
          <span className="bq-footer__year">© {year}</span>
          <span className="bq-footer__standard">W3C VC · OpenBadges 3.0</span>
        </div>
      </div>
    </footer>
  );
}
